"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

require("./button.scss");

var DefaultBtn = function DefaultBtn(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "onClick", "disabled", "children"]);
  var cls = "btn--default ".concat(className || "", " ").concat(disabled ? "disabled" : "");
  return /*#__PURE__*/_react["default"].createElement("button", Object.assign({
    className: cls,
    onClick: onClick,
    disabled: disabled
  }, rest), children);
};

var _default = DefaultBtn;
exports["default"] = _default;